import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLang } from '../i18n/LanguageContext';
import styles from './Locations.module.css';

const CITIES = [
  'Vienna',
  'Copenhagen',
  'Helsinki',
  'Gothenburg',
  'Amsterdam',
  'London',
  'Paris',
  'Lille',
  'Lisbon',
  'Madrid',
  'Barcelona',
  'Milan',
  'Bologna',
  'Athens',
  'Nicosia',
  'Istanbul',
  'Bucharest',
  'Warsaw',
  'Vilnius',
  'Tel Aviv',
];

export default function Locations() {
  const revealRef = useScrollReveal();
  const { t, tr } = useLang();

  return (
    <section id="locations" className={styles.section} aria-label={t('locations.eyebrow')}>
      <div className={`container reveal ${styles.inner}`} ref={revealRef}>
        <p className="section-label">{t('locations.eyebrow')}</p>
        <h2 className={styles.headline}>{tr("Where we've filmed.", 'Wo wir gedreht haben.')}</h2>
        <p className={styles.subtext}>
          {tr(
            <>
              18 countries and counting. Home base is Berlin. But if your event is happening,
              we&apos;re probably already packing.
            </>,
            <>
              18 Länder und es werden mehr. Homebase ist Berlin. Aber wenn Ihr Event stattfindet,
              packen wir wahrscheinlich schon.
            </>,
          )}
        </p>

        <p className={styles.list}>
          <span className={`${styles.item} ${styles.home}`}>
            {tr('All over Germany', 'In ganz Deutschland')}
          </span>
          {CITIES.map((city) => (
            <span key={city} className={styles.item}>
              {city}
            </span>
          ))}
        </p>
      </div>
    </section>
  );
}
